export const CART_QUERY_KEY = ["cart"] as const;
